import React from "react";
import Collapsible from "react-collapsible";
import {Box, Columns, Table} from "react-bulma-components";


export default function Option({category, options}){
    // filter options for the category
    let filteredOptions = options.results.filter((option) => option.category.id === category.id);
    return (
        <Box>
            <Collapsible
                trigger={category.name ?? "ERROR"}
                triggerOpenedClassName={"title"}
                className={"title"}
            >
                <Columns>
                    <Columns.Column>
                        <Table
                            size={"fullwidth"}
                        >
                            <tr>
                                <th>Name</th>
                                <th>Status</th>
                            </tr>
                            <tbody>
                            {filteredOptions.map((item, index) => (
                                <tr key={item.xero_id}>
                                    <td>{item.name}</td>
                                    <td>{item.status}</td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </Columns.Column>
                </Columns>
            </Collapsible>
        </Box>
    )


}